import axios from 'axios'

export const state = {
  systemSettings: [],
}

export const getters = {
  getsystemSettings() {
    return state.systemSettings
  },
}

export const mutations = {
  SET_SYSTEM_SETTINGS(state, systemSettings) {
    state.systemSettings = systemSettings
  },
}

export const actions = {
  // getAllsystemSettings({
  //   commit
  // }, {
  //   groupId
  // }) {
  //   return axios.get(`v1/systemSettings/${groupId}`, {
  //     params: params
  //   }).then(response => {
  //     return response
  //   })
  // },

  getAllsystemSettings({
    commit
  }, outletId) {
    return axios.get(`v1/systemSettings/${outletId}`).then(response => {
      return response
    })
  },

  getOLOsystemSettings({
    commit
  }, outletId) {
    return axios.get(`v1/oloSettings/${outletId}`).then(response => {
      return response
    })
  },

  updateOLOsystemSettings({
    commit,
    state
  }, {
    oloSettingsDetails
  }) {
    return axios
      .put(`v1/oloSettings/`, oloSettingsDetails)
      .then(response => {
        return response
      })
  },

  setAllsystemSettings({
    commit,
    state
  }, systemSettings) {
    commit('SET_SYSTEM_SETTINGS', systemSettings)
  },

  updatesystemSettings({
    commit,
    state
  }, {
    systemSettingsDetails
  }) {
    return axios
      .put(`v1/systemSettings/`, systemSettingsDetails)
      .then(response => {
        return response
      })
  },
}
